import { UbudStorageModule } from '@ubud/storage';
import { NgModule } from '@angular/core';
import { UserService } from '@lemsar/user/domains/services/user.service';

/**
 *  @author     Arif Setianto <arifsetiantoo@gmail.com>
 *  @created    20/06/2018
 */
@NgModule({
    imports: [UbudStorageModule],
    providers: [UserService],
})
export class LemsarUserDomainModule {}



// WEBPACK FOOTER //
// ./src/lemsar/user/domains/module.ts